import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import OutlinedInput from '@material-ui/core/OutlinedInput';

const styles = theme => ({
  input: {
    marginTop: '5px'
  },
  root: {
    marginTop: '5px'
  },
  formControl: {
    width: '100%',
    marginBottom: '20px'
  },
  halfControl: {
    width: '168px',
    [theme.breakpoints.down('xs')]: {
      width: '100%'
    }
  }
});

class GroupSelect extends React.Component {
  static propTypes = {
    label: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func,
    options: PropTypes.arrayOf(PropTypes.object),
    id: PropTypes.string,
    classes: PropTypes.object,
    disabled: PropTypes.bool,
    fullWidth: PropTypes.bool
  };

  /**
   * build the optgroup tags and options for each
   * value
   */
  buildMultipleOptionsGroups = () => {
    const { options } = this.props;
    return options.map((optionGroup, index) => {
      const groupName = optionGroup.label;
      const groupValues = optionGroup.values;

      return (
        <optgroup key={index} label={groupName}>
          {groupValues.map((option, index) => (
            <option disabled={option.disabled} key={index} value={option.value}>
              {option.label}
            </option>
          ))}
        </optgroup>
      );
    });
  };

  /**
   * Build options without option groups if it only spans one day
   */
  buildOptions = () => {
    const { options } = this.props;
    const optionGroup = options[0];
    return optionGroup.values.map((option, index) => (
      <option disabled={option.disabled} key={index} value={option.value}>
        {option.label}
      </option>
    ));
  };

  render() {
    const {
      label,
      value,
      onChange,
      id,
      classes,
      disabled,
      fullWidth,
      options
    } = this.props;
    const {
      formControl,
      inputLabel,
      input,
      halfControl,
      ...muiSelectClass
    } = classes;
    return (
      <FormControl
        className={fullWidth ? classes.formControl : classes.halfControl}
      >
        <InputLabel className={classes.inputLabel} htmlFor={id}>
          {label}
        </InputLabel>
        <Select
          native
          data-testid={id}
          classes={muiSelectClass}
          value={value}
          onChange={onChange}
          disabled={disabled}
          variant="outlined"
          className={classes.selectField}
          input={<OutlinedInput id={id} />}
        >
          {options.length === 1
            ? this.buildOptions()
            : this.buildMultipleOptionsGroups()}
        </Select>
      </FormControl>
    );
  }
}

export default withStyles(styles)(GroupSelect);
